(function () {
  if (window.__invoiceRequestWidgetAppV5Loaded) return;
  window.__invoiceRequestWidgetAppV5Loaded = true;

  const LOCALE = (document.documentElement.lang || "").toLowerCase().startsWith("it") ? "it" : "en";

  const strings = {
    it: {
      saving: "Sto registrando la richiesta fattura...",
      saved: "Richiesta fattura registrata. Prosegui al checkout e inserisci Codice Fiscale e PEC nei campi dedicati. Le richieste incomplete non saranno prese in carico.",
      companySaved: "Dati fattura azienda registrati.",
      reverseChargeGranted: "VAT valido. Richiesta salvata. Usa la stessa email al checkout per mantenere il reverse charge.",
      vatExemptApplied: "VAT valido. Cliente preparato come tax exempt. Usa la stessa email al checkout.",
      manualReviewSaved: "Richiesta salvata per verifica manuale. Controlleremo il VAT prima della fatturazione.",
      emailRequired: "Inserisci l’email che userai al checkout. Serve per preparare il profilo cliente per il reverse charge.",
      error: "Non sono riuscito a registrare la richiesta. Riprova.",
      resetError: "Non sono riuscito ad aggiornare la richiesta fattura. Riprova.",
    },
    en: {
      saving: "Saving invoice request...",
      saved: "Invoice request saved. Continue to checkout and enter your fiscal code and certified email/PEC in the dedicated fields. Incomplete requests will not be processed.",
      companySaved: "Company invoice details saved.",
      reverseChargeGranted: "VAT valid. Invoice request saved. Use the same email at checkout to keep reverse charge.",
      vatExemptApplied: "VAT valid. Customer prepared as tax exempt. Use the same email at checkout.",
      manualReviewSaved: "Invoice request saved for manual review. We will check the VAT before invoicing.",
      emailRequired: "Enter the email you will use at checkout. It is required to prepare the customer profile for reverse charge.",
      error: "Could not save the invoice request. Please try again.",
      resetError: "Could not update the invoice request. Please try again.",
    },
  };

  const t = strings[LOCALE] || strings.en;
  let syncing = false;
  let syncTimer = null;

  function widgetFrom(element) {
    return element && element.closest ? element.closest("[data-invoice-request-widget]") : null;
  }

  function setMessage(widget, text, type) {
    const message = widget && widget.querySelector ? widget.querySelector("[data-invoice-message]") : null;
    if (!message) return;

    message.textContent = text || "";
    message.classList.remove("is-success", "is-error", "is-loading");

    if (type === "error") message.classList.add("is-error");
    if (type === "success") message.classList.add("is-success");
    if (type === "loading") message.classList.add("is-loading");
  }

  function setPanels(widget, value) {
    const privatePanel = widget.querySelector("[data-invoice-private]");
    const companyPanel = widget.querySelector("[data-invoice-company]");

    if (privatePanel) privatePanel.hidden = value !== "private";
    if (companyPanel) companyPanel.hidden = value !== "company";

    updateItalianFiscalFields(widget);
  }

  function setChecked(widget, value) {
    const input = widget.querySelector(`input[name="invoice_type"][value="${value}"]`);
    if (input) input.checked = true;
    setPanels(widget, value || "none");
  }

  function setBusy(widget, busy) {
    if (!widget) return;
    widget.toggleAttribute("data-invoice-busy", Boolean(busy));

    widget.querySelectorAll('input[name="invoice_type"], [data-invoice-validate]').forEach((element) => {
      element.disabled = Boolean(busy);
    });
  }

  function normalizeBool(value) {
    return value === true || value === "true" || value === "1" || value === 1;
  }

  function getCompanyCountry(widget) {
    return (widget.querySelector("[data-invoice-country]")?.value || "IT").toUpperCase();
  }

  function isLoggedCustomer(widget) {
    return widget?.dataset?.invoiceCustomerLoggedIn === "true";
  }

  function getLoggedCustomerEmail(widget) {
    return widget?.dataset?.invoiceCustomerEmail || "";
  }

  function updateItalianFiscalFields(widget) {
    if (!widget) return;

    const country = getCompanyCountry(widget);
    const isItaly = country === "IT";
    const isLogged = isLoggedCustomer(widget);

    widget.querySelectorAll("[data-invoice-it-field]").forEach((field) => {
      field.hidden = !isItaly;

      field.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !isItaly;
        if (!isItaly) input.value = "";
      });
    });

    widget.querySelectorAll("[data-invoice-non-it-field]").forEach((field) => {
      field.hidden = isItaly;

      field.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = isItaly;
        if (isItaly) input.value = "";
      });
    });

    widget.querySelectorAll("[data-invoice-non-it-guest-field]").forEach((field) => {
      const shouldHide = isItaly || isLogged;
      field.hidden = shouldHide;

      field.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = shouldHide;
        if (shouldHide && isLogged) input.value = getLoggedCustomerEmail(widget);
        if (isItaly) input.value = "";
      });
    });
  }

  function getCompanySuccessMessage(proxyData) {
    if (proxyData?.message) return proxyData.message;
    if (proxyData?.pendingManualReview) return t.manualReviewSaved;
    if (proxyData?.taxExemptApplied || proxyData?.taxExemptCustomerPrepared) return t.vatExemptApplied;
    if (proxyData?.reverseCharge) return t.reverseChargeGranted;
    return t.companySaved;
  }

  async function getCart() {
    const response = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });

    if (!response.ok) throw new Error("Cart read failed");
    return response.json();
  }

  async function saveCartAttributes(attributes) {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) throw new Error("Cart update failed");
    return response.json();
  }

  async function saveInvoiceRequest(payload) {
    const cart = await getCart();

    const response = await fetch("/apps/invoice-request/validate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        cartToken: cart.token || "",
        locale: LOCALE,
        ...payload,
      }),
    });

    let data = {};
    try {
      data = await response.json();
    } catch (_error) {
      data = {};
    }

    if (!response.ok || !data.ok) {
      throw new Error(data.error || "Invoice request failed");
    }

    return data;
  }

  async function clearInvoiceRequest() {
    await saveCartAttributes({
      invoice_requested: "",
      invoice_type: "",
      invoice_request_status: "",
      invoice_request_id: "",
      vat_number: "",
      invoice_country_code: "",
      pec: "",
      sdi: "",
      company_name: "",
      vies_checked: "",
      vies_valid: "",
      reverse_charge: "",
      tax_exempt_applied: "",
      tax_exempt_customer_prepared: "",
      customer_email: "",
      must_use_same_email_at_checkout: "",
    });
  }

  async function handleTypeChange(input) {
    const widget = widgetFrom(input);
    if (!widget) return;

    const value = input.value;
    setPanels(widget, value);

    if (value === "none") {
      setBusy(widget, true);
      setMessage(widget, "", null);

      try {
        await clearInvoiceRequest();
        setPanels(widget, "none");
      } catch (_error) {
        setMessage(widget, t.resetError, "error");
      } finally {
        setBusy(widget, false);
      }

      return;
    }

    if (value === "private") {
      setBusy(widget, true);
      setPanels(widget, "private");
      setMessage(widget, t.saving, "loading");

      try {
        const proxyData = await saveInvoiceRequest({
          invoiceType: "private",
        });

        await saveCartAttributes({
          invoice_requested: "true",
          invoice_type: "private",
          invoice_request_status: "registered",
          invoice_request_id: proxyData.invoiceRequestId || "",
          vat_number: "",
          invoice_country_code: "",
          pec: "",
          sdi: "",
          company_name: "",
          vies_checked: "false",
          vies_valid: "",
          reverse_charge: "false",
          tax_exempt_applied: "false",
        });

        setChecked(widget, "private");
        setMessage(widget, t.saved, "success");
      } catch (error) {
        setChecked(widget, "private");
        setMessage(widget, error.message || t.error, "error");
      } finally {
        setBusy(widget, false);
      }

      return;
    }

    if (value === "company") {
      setPanels(widget, "company");
      setMessage(widget, "", null);
    }
  }

  async function handleCompanySave(button) {
    const widget = widgetFrom(button);
    if (!widget) return;

    updateItalianFiscalFields(widget);

    const country = getCompanyCountry(widget);
    const isItaly = country === "IT";
    const vat = widget.querySelector("[data-invoice-vat]")?.value || "";
    const companyName = widget.querySelector("[data-invoice-company-name]")?.value || "";
    const isLogged = isLoggedCustomer(widget);
    const email = isItaly
      ? ""
      : isLogged
        ? getLoggedCustomerEmail(widget)
        : widget.querySelector("[data-invoice-company-email]")?.value || "";
    const pec = isItaly ? widget.querySelector("[data-invoice-pec]")?.value || "" : "";
    const sdi = isItaly ? widget.querySelector("[data-invoice-sdi]")?.value || "" : "";

    if (!isItaly && !isLogged && !String(email).trim()) {
      setChecked(widget, "company");
      setPanels(widget, "company");
      setMessage(widget, t.emailRequired, "error");
      return;
    }

    setBusy(widget, true);
    setPanels(widget, "company");
    setMessage(widget, t.saving, "loading");

    try {
      const proxyData = await saveInvoiceRequest({
        invoiceType: "company",
        countryCode: country,
        vatNumber: vat,
        companyName,
        customerEmail: email,
        pec,
        sdi,
      });

      await saveCartAttributes({
        invoice_requested: "true",
        invoice_type: "company",
        invoice_country_code: country,
        vat_number: proxyData.vatNumber || vat,
        company_name: companyName,
        customer_email: proxyData.customerEmail || email,
        pec,
        sdi,
        invoice_request_status: "registered",
        invoice_request_id: proxyData.invoiceRequestId || "",
        vies_checked: proxyData.viesChecked ? "true" : "false",
        vies_valid:
          proxyData.viesValid === true ? "true" : proxyData.viesValid === false ? "false" : "",
        reverse_charge: proxyData.reverseCharge ? "true" : "false",
        tax_exempt_applied: proxyData.taxExemptApplied ? "true" : "false",
        tax_exempt_customer_prepared: proxyData.taxExemptCustomerPrepared ? "true" : "false",
        must_use_same_email_at_checkout: proxyData.mustUseSameEmailAtCheckout ? "true" : "false",
      });

      setChecked(widget, "company");
      updateItalianFiscalFields(widget);
      setMessage(widget, getCompanySuccessMessage(proxyData), "success");
    } catch (error) {
      setChecked(widget, "company");
      setMessage(widget, error.message || t.error, "error");
    } finally {
      setBusy(widget, false);
    }
  }

  function applyCartStateToWidget(widget, cart) {
    if (!widget || !cart) return;

    const attributes = cart.attributes || {};
    const requested = normalizeBool(attributes.invoice_requested);
    const type = requested ? attributes.invoice_type || "none" : "none";

    setChecked(widget, type);

    if (requested && type === "private") {
      setMessage(widget, t.saved, "success");
    }

    if (requested && type === "company") {
      const countryInput = widget.querySelector("[data-invoice-country]");
      const vatInput = widget.querySelector("[data-invoice-vat]");
      const companyNameInput = widget.querySelector("[data-invoice-company-name]");
      const pecInput = widget.querySelector("[data-invoice-pec]");
      const sdiInput = widget.querySelector("[data-invoice-sdi]");
      const emailInput = widget.querySelector("[data-invoice-company-email]");

      if (countryInput && attributes.invoice_country_code) countryInput.value = attributes.invoice_country_code;
      if (vatInput && attributes.vat_number) vatInput.value = attributes.vat_number;
      if (companyNameInput && attributes.company_name) companyNameInput.value = attributes.company_name;
      if (emailInput && attributes.customer_email) emailInput.value = attributes.customer_email;
      if (pecInput && attributes.pec) pecInput.value = attributes.pec;
      if (sdiInput && attributes.sdi) sdiInput.value = attributes.sdi;

      updateItalianFiscalFields(widget);

      if (attributes.invoice_request_status === "pending_review") {
        setMessage(widget, t.manualReviewSaved, "success");
      } else if (normalizeBool(attributes.tax_exempt_applied) || normalizeBool(attributes.tax_exempt_customer_prepared)) {
        setMessage(widget, t.vatExemptApplied, "success");
      } else if (normalizeBool(attributes.reverse_charge)) {
        setMessage(widget, t.reverseChargeGranted, "success");
      } else {
        setMessage(widget, t.companySaved, "success");
      }
    }
  }

  async function syncExistingWidgets() {
    if (syncing) return;
    syncing = true;

    try {
      const widgets = Array.from(document.querySelectorAll("[data-invoice-request-widget]"));
      if (!widgets.length) return;

      const cart = await getCart();
      widgets.forEach((widget) => applyCartStateToWidget(widget, cart));
    } catch (_error) {
      document.querySelectorAll("[data-invoice-request-widget]").forEach((widget) => {
        const checked = widget.querySelector('input[name="invoice_type"]:checked');
        setPanels(widget, checked ? checked.value : "none");
      });
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncExistingWidgets, 100);
  }

  document.addEventListener("change", function (event) {
    const input = event.target;

    if (input && input.matches && input.matches('[data-invoice-request-widget] [data-invoice-country]')) {
      const widget = widgetFrom(input);
      updateItalianFiscalFields(widget);
      setMessage(widget, "", null);
      return;
    }

    if (input && input.matches && input.matches('[data-invoice-request-widget] input[name="invoice_type"]')) {
      handleTypeChange(input);
    }
  });

  document.addEventListener("click", function (event) {
    const button = event.target && event.target.closest ? event.target.closest("[data-invoice-validate]") : null;
    if (!button) return;

    event.preventDefault();
    handleCompanySave(button);
  });

  document.addEventListener("DOMContentLoaded", scheduleSync);
  document.addEventListener("shopify:section:load", scheduleSync);
  document.addEventListener("cart:refresh", scheduleSync);
  document.addEventListener("cart:updated", scheduleSync);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

      for (const node of mutation.addedNodes) {
        if (!node || node.nodeType !== 1) continue;

        if (
          node.matches?.("[data-invoice-request-widget]") ||
          node.querySelector?.("[data-invoice-request-widget]")
        ) {
          scheduleSync();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  scheduleSync();
})();
